import SHA256 from 'crypto-js/sha256'

export const decodeAuthNetCollectorId = (collectorId: string): string => {
    return SHA256(collectorId).toString()
}
